import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

export const gigProposalPayoutsList = (params = '') => Http.get(`/admin/gigs/proposals${serialize(params)}`)
export const gigProposalPayoutMark  = (params = '') => Http.put(`/admin/gigs/proposals/${params.id}/payout`, params)
